<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div
            class="white--text"
            v-html="text"
          />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Dirección',
          text: 'Km 13 Vía El Faro<br>Cali | Colombia',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Telefono',
          text: '(+57) 3187351034<br>(+57) 3187351034',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'hola@amatea.org<br>amatea@amatea.org',
        },
      ],
    }),
  }
</script>
